export default __webpack_public_path__ + "static/media/history.ea453b9f.svg";